import { array, literal, object, union } from 'superstruct';

import { adflowApiSchema } from '@adflow/shared/util-route-schema';
import { parsableInteger } from '@adflow/shared/util-superstruct';

import { AddEditRoleErrorDto } from './add-edit-role-error.dto';
import { AddRoleDto } from './add-role.dto';
import { EditRoleDto } from './edit-role.dto';
import { ViewRoleDto } from './view-role.dto';

const p = adflowApiSchema.prefix('roles');

export const ListRoles = p.get('', {
	req: object({}),
	res: array(ViewRoleDto),
});

export const GetRole = p.get(':roleId', {
	req: object({
		params: object({ roleId: parsableInteger() }),
	}),
	res: ViewRoleDto,
});

export const AddRole = p.post('', {
	req: object({
		body: AddRoleDto,
	}),
	res: union([ViewRoleDto, AddEditRoleErrorDto]),
});

export const EditRole = p.patch(':roleId', {
	req: object({
		params: object({ roleId: parsableInteger() }),
		body: EditRoleDto,
	}),
	res: union([ViewRoleDto, AddEditRoleErrorDto]),
});

export const ArchiveRole = p.delete(':roleId', {
	req: object({
		params: object({ roleId: parsableInteger() }),
	}),
	res: literal(undefined),
});
